//--- 点を打つ　小数を渡すと参照不能だが丸める責任は渡す側にあり
function dot(image, pixelColor, x, y) {
  image.data.set(pixelColor, (y * image.width + x) * 4);
}

//--- 指定幅の点を打つ　getTickRectで範囲内に限定される
export function dotThick(image, pixelColor, centerX, centerY, thick) {
  const [startX, startY, endX, endY] = getThickRect(centerX, centerY, thick, image.width, image.height);
  for(let y = startY; y < endY; ++y) {
    for(let x = startX; x < endX; ++x) {
      dot(image, pixelColor, x, y);
    }
  }
}

//--- 指定された中心座標と太さから画像上の範囲を計算する
export function getThickRect(centerX, centerY, thick, width, height) {
  [centerX, centerY, thick] = [centerX, centerY, thick].map(Math.floor);
  const half = Math.floor(thick / 2);
  const left = centerX - half;
  const top = centerY - half;
  const startX = Math.max(0, left);
  const startY = Math.max(0, top);
  const endX = Math.min(left + thick, width);
  const endY = Math.min(top + thick, height);
  return [startX, startY, endX, endY];
}

// 線を引く
export function drawLine(image, pixelColor, x1, y1, x2, y2, thick) {
  drawLineBase(x1, y1, x2, y2, (x, y) => dotThick(image, pixelColor, x, y, thick));
}

// 線を引く計算を担う
export function drawLineBase(x1, y1, x2, y2, draw) {
  [x1, y1, x2, y2] = [x1, y1, x2, y2].map(Math.floor);

  const a = (y2 - y1) / (x2 - x1) || 0;
  
  if(1 < Math.abs(a)) {
    const f = y => (y - y1) / a + x1;
    const sign = Math.sign(y2 - y1) || 1;
    for(let y = y1; y * sign <= y2 * sign; y += sign) {
      const x = Math.round(f(y));
      draw(x, y);
    }
  } else {
    const f = x => a * (x - x1) + y1;
    const sign = Math.sign(x2 - x1) || 1;
    for(let x = x1; x * sign <= x2 * sign; x += sign) {
      const y = Math.round(f(x));
      draw(x, y);
    }
  }
}

//--- 曲線を引く
export function drawCurve(image, pixelColor, x1, y1, cpx, cpy, x2, y2, thick) {
  let prevX = x1;
  let prevY = y1;

  // x1, y1, x2, y2の距離を求める
  const dist = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);

  // 0から1までの間を何分割するか
  const max = Math.max(8, Math.floor(dist / 4));
  
  for (let i = 0; i <= max; ++i) {
    let t = i / max || 0;
    let x = Math.round((1 - t) * (1 - t) * x1 + 2 * (1 - t) * t * cpx + t * t * x2);
    let y = Math.round((1 - t) * (1 - t) * y1 + 2 * (1 - t) * t * cpy + t * t * y2);
    drawLine(image, pixelColor, prevX, prevY, x, y, thick);
    prevX = x;
    prevY = y;
  }
}

//--- 塗りつぶし
export function fill(image, pixelColor, x, y, includeDiagonals, distRGB = 0, distA = 0) {
  [x, y] = [x, y].map(Math.floor);
  const blots = [{x, y}];
  const {data, width, height} = image;
  const oldIdx = (y * width + x) * 4;
  const oldPixelColor = data.slice(oldIdx, oldIdx + 4);
  const flags = new Uint8Array(width * height);
  do {
    const blot = blots.shift();
    if(0 <= blot.x && blot.x < width && 0 <= blot.y && blot.y < height) {
      const i = (blot.y * width + blot.x) * 4;
      if(!(flags[i / 4] & 1) && isSimilarColor(data, i, oldPixelColor, 0, distRGB, distA)) {
        flags[i / 4] |= 1;
        data.set(pixelColor, i);
        blots.push({x: blot.x - 1, y: blot.y});
        blots.push({x: blot.x + 1, y: blot.y});
        blots.push({x: blot.x, y: blot.y - 1});
        blots.push({x: blot.x, y: blot.y + 1});
        if(includeDiagonals) {
          blots.push({x: blot.x - 1, y: blot.y - 1});
          blots.push({x: blot.x + 1, y: blot.y - 1});
          blots.push({x: blot.x - 1, y: blot.y + 1});
          blots.push({x: blot.x + 1, y: blot.y + 1});
        }
      }
    }
  } while(blots.length);
}

//--- フチ取り／残し塗りつぶし
export function fillEdge(image, pixelColor, x, y, arrowKeys, leave, includeDiagonals, distRGB = 0, distA = 0) {
  [x, y] = [x, y].map(Math.floor);
  const blots = [{x, y}];
  const {data, width, height} = image;
  const oldIdx = (y * width + x) * 4;
  const oldPixelColor = data.slice(oldIdx, oldIdx + 4);
  const flags = new Uint8Array(width * height);
  do {
    const blot = blots.shift();
    if(0 <= blot.x && blot.x < width && 0 <= blot.y && blot.y < height) {
      const j = blot.y * width + blot.x;
      const i = j * 4;
      if((flags[j] & 1) === 0 && isSimilarColor(data, i, oldPixelColor, 0, distRGB, distA)) {
        flags[j] |= 1;
        if(0 <= blot.x - 1) flags[blot.y * width + blot.x - 1] |= 2; else flags[j] |= 4;
        if(blot.x + 1 < width) flags[blot.y * width + blot.x + 1] |= 4; else flags[j] |= 2;
        if(0 <= blot.y - 1) flags[(blot.y - 1) * width + blot.x] |= 8; else flags[j] |= 16;
        if(blot.y + 1 < height) flags[(blot.y + 1) * width + blot.x] |= 16; else flags[j] |= 8;
        blots.push({x: blot.x - 1, y: blot.y});
        blots.push({x: blot.x + 1, y: blot.y});
        blots.push({x: blot.x, y: blot.y - 1});
        blots.push({x: blot.x, y: blot.y + 1});
        if(includeDiagonals) {
          blots.push({x: blot.x - 1, y: blot.y - 1});
          blots.push({x: blot.x + 1, y: blot.y - 1});
          blots.push({x: blot.x - 1, y: blot.y + 1});
          blots.push({x: blot.x + 1, y: blot.y + 1});
        }
      }
    }
  } while(blots.length);

  if(leave) {
    for(let i = 0; i < flags.length; ++i) {
      if((flags[i] & 1) && ((flags[i] & (2|4|8|16)) === (2|4|8|16))) {
        data.set(pixelColor, i * 4);
      }
    }
  } else {
    for(let i = 0; i < flags.length; ++i) {
      /*if((flags[i] & 1) && ((flags[i] & (2|4|8|16)) !== (2|4|8|16))) {
        data.set(pixelColor, i * 4);
      }*/
      if(flags[i] & 1) {
        if(
          !arrowKeys.any && ((flags[i] & (2|4|8|16)) !== (2|4|8|16)) ||
          arrowKeys.r && !(flags[i] & 2) ||
          arrowKeys.l && !(flags[i] & 4) ||
          arrowKeys.d && !(flags[i] & 8) ||
          arrowKeys.u && !(flags[i] & 16)
        ) {
          data.set(pixelColor, i * 4);
        }
      }
    }
  }
}

//--- ジャギ取り
export function eraseJaggies(image, x, y, distRGB = 0, distA = 0) {
  [x, y] = [x, y].map(Math.floor);
  const blots = [{x, y, from: 0}];
  const {data, width, height} = image;
  const stdIdx = (y * width + x) * 4;
  const stdPixelColor = data.slice(stdIdx, stdIdx + 4);
  const flags = new Uint8Array(width * height);
  do {
    const blot = blots.shift();
    if(0 <= blot.x && blot.x < width && 0 <= blot.y && blot.y < height) {
      const idx = (x, y) => (blot.y + y) * width + (blot.x + x);
      const j = idx(0, 0);
      const i = j * 4;
      if((flags[j] & 1) === 0) {
        if(isSimilarColor(data, j * 4, stdPixelColor, 0, distRGB, distA)) {
          flags[j] |= 1;  // 自分に「検証済み」フラグを立てる
          blots.push({x: blot.x - 1, y: blot.y, from: 1});  // 左に「右から来た」を渡す
          blots.push({x: blot.x + 1, y: blot.y, from: -1});  // 右に「左から来た」を渡す
          blots.push({x: blot.x, y: blot.y - 1, from: 2});  // 上に「下から来た」を渡す
          blots.push({x: blot.x, y: blot.y + 1, from: -2});  // 下に「上から来た」を渡す
        } else {
          switch(blot.from) {
          case 1:
            if(0 <= blot.x - 1) {
              // blotが来た方向の反対が自分と同じ色なら
              const k = idx(-1, 0);
              if(isSimilarColor(data, k * 4, data, i, distRGB, distA)) {
                flags[j] |= 2;  // 左がblotの指すピクセルと、右がstdPixelColorと同じ
                if(
                  // 左と上がblotの指すピクセルと、右と下がstdPixelColorと同じ
                  (flags[j] & 8) && !isSimilarColor(data, idx(-1, -1) * 4, data, i, distRGB, distA) ||
                  // 左と下がblotの指すピクセルと、右と上がstdPixelColorと同じ
                  (flags[j] & 16) && !isSimilarColor(data, idx(-1, 1) * 4, data, i, distRGB, distA)
                ) {
                  flags[k] |= 1;  // 相手に「検証済み」フラグを立てる
                  data.set(stdPixelColor, i);
                }
              }
            }
            break;
          case -1:
            if(blot.x + 1 < width) {
              const k = idx(1, 0);
              if(isSimilarColor(data, k * 4, data, i, distRGB, distA)) {
                flags[j] |= 4;
                if(
                  (flags[j] & 8) && !isSimilarColor(data, idx(1, -1) * 4, data, i, distRGB, distA) ||
                  (flags[j] & 16) && !isSimilarColor(data, idx(1, 1) * 4, data, i, distRGB, distA)
                ) {
                  flags[k] |= 1;
                  data.set(stdPixelColor, i);
                }
              }
            }
            break;
          case 2:
            if(0 <= blot.y - 1) {
              const k = idx(0, -1);
              if(isSimilarColor(data, k * 4, data, i, distRGB, distA)) {
                flags[j] |= 8;
                if(
                  (flags[j] & 2) && !isSimilarColor(data, idx(-1, -1) * 4, data, i, distRGB, distA) ||
                  (flags[j] & 4) && !isSimilarColor(data, idx(1, -1) * 4, data, i, distRGB, distA)
                ) {
                  flags[k] |= 1;
                  data.set(stdPixelColor, i);
                }
              }
            }
            break;
          case -2:
            if(blot.y + 1 < height) {
              const k = idx(0, 1);
              if(isSimilarColor(data, k * 4, data, i, distRGB, distA)) {
                flags[j] |= 16;
                if(
                  (flags[j] & 2) && !isSimilarColor(data, idx(-1, 1) * 4, data, i, distRGB, distA) ||
                  (flags[j] & 4) && !isSimilarColor(data, idx(1, 1) * 4, data, i, distRGB, distA)
                ) {
                  flags[k] |= 1;
                  data.set(stdPixelColor, i);
                }
              }
            }
            break;
          }
        }
      }
    }
  } while(blots.length);
}

//--- 色置換
export function replaceColor(image, dstColor, srcColor, distRGB = 0, distA = 0) {
  const {data} = image;
  for(let i = 0; i < data.length; i += 4) {
    if(isSimilarColor(data, i, srcColor, 0, distRGB, distA)) {
      data.set(dstColor, i);
    }
  }
}

//--- 矩形を描画
export function drawRect(image, pixelColor, x1, y1, x2, y2, thick, fill) {
  const {width, height} = image;
  [x1, y1, x2, y2] = [x1, y1, x2, y2].map(Math.floor);
  [x1, x2] = x1 < x2 ? [x1, x2] : [x2, x1]; 
  [y1, y2] = y1 < y2 ? [y1, y2] : [y2, y1]; 
  const contentX1 = Math.max(0, x1 + thick);
  const contentY1 = Math.max(0, y1 + thick);
  const contentX2 = Math.min(x2 - thick, width - 1);
  const contentY2 = Math.min(y2 - thick, height - 1);
  x1 = Math.max(0, x1);
  y1 = Math.max(0, y1);
  x2 = Math.min(x2, width - 1);
  y2 = Math.min(y2, height - 1);
  for(let y = y1; y <= y2; ++y) {
    for(let x = x1; x <= x2; ++x) {
      if(!fill && contentY1 <= y && y <= contentY2 && contentX1 <= x && x <= contentX2) {
      } else {
        dot(image, pixelColor, x, y);
      }
    }
  }
}

//--- 楕円を描画
export function drawCircle(image, pixelColor, x1, y1, x2, y2, thick, fill) {
  [x1, y1, x2, y2] = [x1, y1, x2, y2].map(Math.floor);
  [x1, x2] = x1 < x2 ? [x1, x2] : [x2, x1]; 
  [y1, y2] = y1 < y2 ? [y1, y2] : [y2, y1];
  const width = x2 - x1 + 1;
  const height = y2 - y1 + 1;
  const outer = new Ellipse(width, height);
  if(thick === 1 && !fill) {
    const halfW = Math.round(width / 2);
    const halfH = Math.round(height / 2);
    const flags = new Uint8Array(halfW * halfH);
    for(let y = 0; y < halfH; ++y) {
      for(let x = 0; x < halfW; ++x) {
        const i = y * halfW + x;
        const p = x - outer.a + .5;
        const q = y - outer.b + .5;
        if(outer.dist(p, q) <= 2*outer.major) {
          flags[i] |= 1;
          if(0 < x) flags[i - 1] |= 2;
          if(x < halfW - 1) flags[i + 1] |= 4; else flags[i] |= 2;
          if(0 < y) flags[i - halfW] |= 8;
          if(y < halfH - 1) flags[i + halfW] |= 16; else flags[i] |= 8;
        }
      }
    }
    for(let y = 0; y < halfH; ++y) {
      for(let x = 0; x < halfW; ++x) {
        const i = y * halfW + x;
        if((flags[i] & 1) && (flags[i] & (2|4|8|16)) !== (2|4|8|16)) {
          dotThick(image, pixelColor, x1 + x, y1 + y, 1);
          dotThick(image, pixelColor, x1 + x, y2 - y, 1);
          dotThick(image, pixelColor, x2 - x, y1 + y, 1);
          dotThick(image, pixelColor, x2 - x, y2 - y, 1);
        }
      }
    }
  } else {
    const inner = new Ellipse(width - 2*thick, height - 2*thick);
    const fx1 = Math.max(0, x1);
    const fy1 = Math.max(0, y1);
    const fx2 = Math.min(x2, image.width - 1);
    const fy2 = Math.min(y2, image.height - 1);
    for(let y = fy1; y <= fy2; ++y) {
      for(let x = fx1; x <= fx2; ++x) {
        const p = x - x1 - outer.a + .5;
        const q = y - y1 - outer.b + .5;
        if(outer.dist(p, q) <= 2*outer.major && (fill || outer.minor <= thick || 2*inner.major < inner.dist(p, q))) {
          dot(image, pixelColor, x, y);
        }
      }
    }
  }
}

//--- RotSprite
export function scale2x(srcImage) {
  const {data: srcData, width, height} = srcImage;
  const dstImage = new ImageData(width * 2, height * 2);
  const {data: dstData} = dstImage;
  const getPixel = (x, y) => {
    if(0 <= x && x < width && 0 <= y && y < height) {
      const layerIdx = y * width + x;
      return srcData.subarray(layerIdx * 4, (layerIdx + 1) * 4);
    } else {
      return new Uint8ClampedArray([0, 0, 0, 0]);
    }
  };
  const getResults = (x, y) => {
    const l = getPixel(x - 1, y);
    const r = getPixel(x + 1, y);
    const t = getPixel(x, y - 1);
    const b = getPixel(x, y + 1);
    const lt = isSameColor(l, 0, t, 0);
    const tr = isSameColor(t, 0, r, 0);
    const rb = isSameColor(r, 0, b, 0);
    const bl = isSameColor(b, 0, l, 0);
    return [lt, tr, rb, bl, l, r, t, b];
  };
  for(let y = 0; y < height; ++y) {
    for(let x = 0; x < width; ++x) {
      const e0 = (y * 2 * width * 2 + x * 2) * 4;
      const e1 = e0 + 4;
      const e3 = e0 + width * 2 * 4;
      const e2 = e3 + 4;  // 時計回り！e3,e2の順番に注意！
      const [lt, tr, rb, bl, l, r, t, b] = getResults(x, y);
      const c = getPixel(x, y);
      if(lt && !tr && !bl) dstData.set(l, e0); else dstData.set(c, e0);
      if(tr && !rb && !lt) dstData.set(t, e1); else dstData.set(c, e1);
      if(rb && !bl && !tr) dstData.set(r, e2); else dstData.set(c, e2);
      if(bl && !lt && !rb) dstData.set(b, e3); else dstData.set(c, e3);
    }
  }
  return dstImage;
}
export function scale3x(srcImage) {
  const {data: srcData, width, height} = srcImage;
  const dstImage = new ImageData(width * 3, height * 3);
  const {data: dstData} = dstImage;
  const getPixel = (x, y) => {
    if(0 <= x && x < width && 0 <= y && y < height) {
      const layerIdx = y * width + x;
      return srcData.subarray(layerIdx * 4, (layerIdx + 1) * 4);
    } else {
      return new Uint8ClampedArray([0, 0, 0, 0]);
    }
  };
  const getResults = (x, y) => {
    const a = getPixel(x - 1, y - 1);
    const b = getPixel(x    , y - 1);
    const c = getPixel(x + 1, y - 1);
    const d = getPixel(x - 1, y    );
    const e = getPixel(x    , y    );
    const f = getPixel(x + 1, y    );
    const g = getPixel(x - 1, y + 1);
    const h = getPixel(x    , y + 1);
    const i = getPixel(x + 1, y + 1);
    const db = isSameColor(d, 0, b, 0);
    const bf = isSameColor(b, 0, f, 0);
    const fh = isSameColor(f, 0, h, 0);
    const hd = isSameColor(h, 0, d, 0);
    const bd = db;
    const fb = bf;
    const hf = fh;
    const dh = hd;
    const ea = isSameColor(e, 0, a, 0);
    const ec = isSameColor(e, 0, c, 0);
    const eg = isSameColor(e, 0, g, 0);
    const ei = isSameColor(e, 0, i, 0);
    return [a, b, c, d, e, f, g, h, i, db, bf, fh, hd, bd, fb, hf, dh, ea, ec, eg, ei];
  };
  for(let y = 0; y < height; ++y) {
    for(let x = 0; x < width; ++x) {
      const [a, b, c, d, e, f, g, h, i, db, bf, fh, hd, bd, fb, hf, dh, ea, ec, eg, ei] = getResults(x, y);
      const e1 = (y * 3 * width * 3 + x * 3) * 4;
      const e2 = e1 + 4;
      const e3 = e2 + 4;
      const e4 = e1 + width * 3 * 4;
      const e5 = e4 + 4;
      const e6 = e5 + 4;
      const e7 = e4 + width * 3 * 4;
      const e8 = e7 + 4;
      const e9 = e8 + 4;
      const lt = db && !dh && !bf;
      const rt = bf && !bd && !fh;
      const lb = hd && !hf && !db;
      const rb = fh && !fb && !hd;
      if(lt) dstData.set(d, e1); else dstData.set(e, e1);
      if((lt && !ec) || (rt && !ea)) dstData.set(b, e2); else dstData.set(e, e2);
      if(rt) dstData.set(b, e3); else dstData.set(e, e3);
      if((lb && !ea) || (lt && !eg)) dstData.set(d, e4); else dstData.set(e, e4);
      dstData.set(e, e5);
      if((rt && !ei) || (rb && !ec)) dstData.set(f, e6); else dstData.set(e, e6);
      if(lb) dstData.set(h, e7); else dstData.set(e, e7);
      if((rb && !eg) || (lb && !ei)) dstData.set(h, e8); else dstData.set(e, e8);
      if(rb) dstData.set(f, e9); else dstData.set(e, e9);
    }
  }
  return dstImage;
}

//--- ピクセル単位で画像の複製などができる 
export function pasteImage(dstImage, srcImage, srcOfsX, srcOfsY, callback) {
  const x1 = Math.max(0, srcOfsX);
  const y1 = Math.max(0, srcOfsY);
  const x2 = Math.min(srcOfsX + srcImage.width, dstImage.width);
  const y2 = Math.min(srcOfsY + srcImage.height, dstImage.height);
  
  for(let dstY = y1; dstY < y2; ++dstY) {
    for(let dstX = x1; dstX < x2; ++dstX) {
      const dstI = dstY * dstImage.width + dstX;
      const srcX = dstX - srcOfsX;
      const srcY = dstY - srcOfsY;
      const srcI = srcY * srcImage.width + srcX;
      if(0 < srcImage.data[srcI * 4 + 3]) {
        const srcPixel = srcImage.data.subarray(srcI * 4, srcI * 4 + 4);
        const dstPixel = dstImage.data.subarray(dstI * 4, dstI * 4 + 4);
        callback(dstPixel, srcPixel, dstI, srcI);
      }
    }
  }
}

/*-------------------------------- 色 --------------------------------*/
//--- 同じ色か比較
export function isSameColor(arr1, idx1, arr2, idx2) {
  const a1 = arr1[idx1 + 3];
  const a2 = arr2[idx2 + 3];
  if(a1 === 0 && a2 === 0) {
    return true;
  } else if(a1 === 0 || a2 === 0) {
    return false;
  } else {
    for(let i = 0; i < 4; ++i) {
      if(arr1[idx1 + i] !== arr2[idx2 + i]) {
        return false;
      }
    }
  }
  return true;
}

//--- 似てる色か比較
export function isSimilarColor(arr1, idx1, arr2, idx2, distRGB, distA) {
  const a1 = arr1[idx1 + 3];
  const a2 = arr2[idx2 + 3];
  if(a1 === 0 && a2 === 0) {
    return true;
  } else if(a1 === 0 || a2 === 0) {
    return false;
  } else {
    const rgb1 = arr1.slice(idx1, idx1 + 3);
    const rgb2 = arr2.slice(idx2, idx2 + 3);
    const lab1 = rgbToLab(...rgb1);
    const lab2 = rgbToLab(...rgb2);
    return ciede2000(...lab1, ...lab2) <= distRGB && Math.abs(a1 - a2) <= distA * 255;
  }
}

// https://qiita.com/hachisukansw/items/09caabe6bec46a2a0858
export function rgbToLab(r,g,b) {
  //https://en.wikipedia.org/wiki/SRGB#The_reverse_transformation
  var r = r / 255;
  var g = g / 255;
  var b = b / 255;

  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

  //https://en.wikipedia.org/wiki/Lab_color_space#CIELAB-CIEXYZ_conversions
  var L;
  var a;
  var b;

  x *= 100;
  y *= 100;
  z *= 100;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (4 / 29);
  y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (4 / 29);
  z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (4 / 29);

  L = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [L, a, b];
}

// https://qiita.com/hachisukansw/items/860f061a2ab7a4f2d06f
export function ciede2000(L1,a1,b1, L2,a2,b2, kL=1,kC=1,kH=1) {
  //http://en.wikipedia.org/wiki/Color_difference#CIEDE2000
  var radianToDegree = function(radian) {return radian * (180 / Math.PI);};
  var degreeToRadian = function(degree) {return degree * (Math.PI / 180);};

  var deltaLp = L2 - L1;
  var L_ = (L1 + L2) / 2;
  var C1 = Math.sqrt(Math.pow(a1, 2) + Math.pow(b1, 2));
  var C2 = Math.sqrt(Math.pow(a2, 2) + Math.pow(b2, 2));
  var C_ = (C1 + C2) / 2;
  var ap1 = a1 + (a1 / 2) *
      (1 - Math.sqrt(
          Math.pow(C_, 7) /
          (Math.pow(C_, 7) + Math.pow(25, 7))
          )
      );
  var ap2 = a2 + (a2 / 2) *
      (1 - Math.sqrt(
          Math.pow(C_, 7) /
          (Math.pow(C_, 7) + Math.pow(25, 7))
          )
      );
  var Cp1 = Math.sqrt(Math.pow(ap1, 2) + Math.pow(b1, 2));
  var Cp2 = Math.sqrt(Math.pow(ap2, 2) + Math.pow(b2, 2));
  var Cp_ = (Cp1 + Cp2) / 2;
  var deltaCp = Cp2 - Cp1;

  var hp1;
  if (b1 == 0 && ap1 == 0) {
      hp1 = 0;
  } else {
      hp1 = radianToDegree(Math.atan2(b1, ap1));
      if (hp1 < 0) {hp1 = hp1 + 360;}
  }
  var hp2;
  if (b2 == 0 && ap2 == 0) {
      hp2 = 0;
  } else {
      hp2 = radianToDegree(Math.atan2(b2, ap2));
      if (hp2 < 0) {hp2 = hp2 + 360;}
  }

  var deltahp;
  if (C1 == 0 || C2 == 0) {
      deltahp = 0;
  } else if (Math.abs(hp1 - hp2) <= 180) {
      deltahp = hp2 - hp1;
  } else if (hp2 <= hp1) {
      deltahp = hp2 - hp1 + 360;
  } else {
      deltahp = hp2 - hp1 - 360;
  }

  var deltaHp = 2 * Math.sqrt(Cp1 * Cp2) * Math.sin(degreeToRadian(deltahp) / 2);

  var Hp_;
  if (Math.abs(hp1 - hp2) > 180) {
      Hp_ =  (hp1 + hp2 + 360) / 2
  } else {
      Hp_ = (hp1 + hp2) / 2
  };

  var T = 1 -
      0.17 * Math.cos(degreeToRadian(Hp_ - 30)) +
      0.24 * Math.cos(degreeToRadian(2 * Hp_)) +
      0.32 * Math.cos(degreeToRadian(3 * Hp_ + 6)) -
      0.20 * Math.cos(degreeToRadian(4 * Hp_ - 63));

  var SL = 1 + (
      (0.015 * Math.pow(L_ - 50, 2)) /
      Math.sqrt(20 + Math.pow(L_ - 50, 2))
      );
  var SC = 1 + 0.045 * Cp_;
  var SH = 1 + 0.015 * Cp_ * T;

  var RT = -2 *
      Math.sqrt(
          Math.pow(Cp_, 7) /
          (Math.pow(Cp_, 7) + Math.pow(25, 7))
      ) *
      Math.sin(degreeToRadian(
          60 * Math.exp(-Math.pow((Hp_ - 275) / 25, 2))
      ));

  return Math.sqrt(
      Math.pow(deltaLp / (kL * SL), 2) +
      Math.pow(deltaCp / (kC * SC), 2) +
      Math.pow(deltaHp / (kH * SH), 2) +
      RT * (deltaCp / (kC * SC)) * (deltaHp / (kH * SH))
      );
}

/*export function testcie(rgbStr1, rgbStr2) {
  const str2rgb = str => {
    let found;
    let r, g, b;
    if(found = str.match(/rgba?\s*\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(1|0|0?\.\d+)\s*)?\)/)) {
      r = parseInt(found[1]);
      g = parseInt(found[2]);
      b = parseInt(found[3]);
      return [r, g, b];
    } else {
      return null;
    }
  }

  const rgb1 = str2rgb(rgbStr1);
  const rgb2 = str2rgb(rgbStr2);
  return ciede2000(...rgbToLab(...rgb1), ...rgbToLab(...rgb2));
}*/

//--- 楕円描画で計算に使用　原点固定
class Ellipse {
  constructor(width, height) {
    this.width = Math.max(0, width);
    this.height = Math.max(0, height);
    this.a = this.width / 2;
    this.b = this.height / 2;
    this.c = Math.sqrt(Math.abs(this.a**2 - this.b**2));
    if(this.a > this.b) {
      this.major = this.a;
      this.minor = this.b;
    } else {
      this.major = this.b;
      this.minor = this.a;
    }
  }
  dist(p, q) {
    if(this.a > this.b) {
      return Math.sqrt((p - this.c)**2 + q**2) + Math.sqrt((p + this.c)**2 + q**2);
    } else {
      return Math.sqrt(p**2 + (q - this.c)**2) + Math.sqrt(p**2 + (q + this.c)**2);
    }
  }
}

/*-------------------------------- 定数 --------------------------------*/
export const ZERO_PIXEL = new Uint8ClampedArray([0, 0, 0, 0]);
